import { render, staticRenderFns } from "./queSheng.vue?vue&type=template&id=9f1873da&scoped=true&"
import script from "./queSheng.vue?vue&type=script&lang=ts&"
export * from "./queSheng.vue?vue&type=script&lang=ts&"
import style0 from "./queSheng.vue?vue&type=style&index=0&id=9f1873da&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f1873da",
  null
  
)

export default component.exports